<div class="merge-tag-picker-overlay">
	<app-merge-tag-picker
		*ngIf="state.visible"
		[data]="state.data"
		[config]="state.config ?? undefined"
		(tagSelected)="onTagSelected($event)"
		(closed)="onClosed()"
		(invalid)="onInvalid($event)"
	></app-merge-tag-picker>
</div>
